/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export class AnnotationSettingsActionsNames {
    static GetAnnotationSettingsFromXMLFile = (): string => '[AnnotationSettings] GetAnnotationSettingsFromXMLFile';
    static GetAnnotationSettingsFromXMLFileSuccess = (): string => '[AnnotationSettings] GetAnnotationSettingsFromXMLFile Success';
    
    static SaveAnnotationSettingsToXmlFile = (): string => '[Annotationsettings] SaveAnnotationSettingsToXmlFile'
    static SaveAnnotationSettingsToXmlFileSuccess = (): string => '[Annotationsettings] SaveAnnotationSettingsToXmlFile Success'
   
    static GetRevitInformation = (): string => '[AnnotationSettings] GetRevitInformation';
    static GetRevitInformationSuccess = (): string => '[AnnotationSettings] GetRevitInformation Success';
    
    static GetTagLocationPath = (): string => '[AnnotationSettings] GetTagLocationPath';
    static GetTagLocationPathSuccess = (): string => '[AnnotationSettings] GetTagLocationPath Success';

    static GetFittingsTagLocationPath = (): string => '[AnnotationSettings] GetFittingsTagLocationPath';
    static GetFittingsTagLocationPathSuccess = (): string => '[AnnotationSettings] GetFittingsTagLocationPath Success';
   
    static IsCurrentSelectionValid = (): string => '[AnnotationSettings] IsCurrentSelectionValid';
    static IsCurrentSelectionValidSuccess = (): string => '[AnnotationSettings] IsCurrentSelectionValid Success';
   
    static ApplyData = (): string => '[AnnotationSettings] ApplyData';
    static ApplyDataSuccess = (): string => '[AnnotationSettings] ApplyData Success';
}